import { List, ListItem } from '@mui/material';
import SelectableCard from '@/components/SelectableCard/SelectableCard';
import useGlobalStyles from '@/styles/global.styles';
import useStyles from './EcommOptionsList.styles';

interface SelectableCardItem {
  id: string;
  label: string;
  disabled?: boolean;
}

interface SelectableCardListProps {
  label: string;
  heading?: string;
  name: string;
  items: SelectableCardItem[] | undefined;
  selectedId: string | undefined;
  onSelect: (id: string) => void;
  onHover?: (id: string, isEntering: boolean) => void;
  optionsContainerClassName?: string;
  cardContentClassName?: string;
  disabledCardContentClassName?: string;
  className?: string;
  increaseCardPadding?: boolean;
  'data-testid'?: string;
}

const EcommOptionsList: React.FC<SelectableCardListProps> = ({
  label,
  heading,
  name,
  items,
  selectedId,
  onSelect,
  onHover,
  cardContentClassName,
  disabledCardContentClassName,
  optionsContainerClassName,
  className,
  increaseCardPadding = false,
  'data-testid': dataTestId,
}) => {
  const { classes, cx } = useStyles();
  const { classes: globalClasses } = useGlobalStyles({ fixed: true });

  return (
    <div
      role='radiogroup'
      aria-label={label}
      data-testid={dataTestId}
      className={className}
    >
      {heading && <h4 className={globalClasses.h4}>{heading}</h4>}

      <List className={cx(classes.optionsContainer, optionsContainerClassName)}>
        {items?.map(({ id, label, disabled }) => (
          <ListItem
            key={id}
            onMouseEnter={() => onHover?.(id, true)}
            onMouseLeave={() => onHover?.(id, false)}
          >
            <SelectableCard
              name={name}
              value={id}
              isSelected={selectedId === id}
              onSelect={() => onSelect(id)}
              ariaLabel={label}
              increasePadding={increaseCardPadding}
              disabled={disabled}
            >
              <div
                className={cx(
                  cardContentClassName,
                  disabled && disabledCardContentClassName
                )}
              >
                {label}
                {disabled && (
                  <span className={classes.notAvailable}>Not available</span>
                )}
              </div>
            </SelectableCard>
          </ListItem>
        ))}
      </List>
    </div>
  );
};

export default EcommOptionsList;
